import { render, staticRenderFns } from "./PresentingCanvasQuestionImageAndHints.vue?vue&type=template&id=2311f19a&scoped=true&"
import script from "./PresentingCanvasQuestionImageAndHints.vue?vue&type=script&lang=js&"
export * from "./PresentingCanvasQuestionImageAndHints.vue?vue&type=script&lang=js&"
import style0 from "./PresentingCanvasQuestionImageAndHints.vue?vue&type=style&index=0&id=2311f19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311f19a",
  null
  
)

export default component.exports